import { render, staticRenderFns } from "./relationGraph.vue?vue&type=template&id=0bd5ea14&scoped=true"
import script from "./relationGraph.vue?vue&type=script&lang=js"
export * from "./relationGraph.vue?vue&type=script&lang=js"
import style0 from "./relationGraph.vue?vue&type=style&index=0&id=0bd5ea14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5ea14",
  null
  
)

export default component.exports